import { BottomSheet } from "./BottomSheet";
import { SubscriptionSection } from "./SubscriptionSection";
import { FREE_BETA } from "../../../lib/featureFlags";

type SubscriptionSheetProps = {
  open: boolean;
  isSubscribed: boolean;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  subscribing: boolean;
  managing: boolean;
  error: string;
  onClose: () => void;
  onSubscribe: () => void;
  onManage: () => void;
};

export const SubscriptionSheet = ({
  open,
  isSubscribed,
  currentPeriodEnd,
  cancelAtPeriodEnd,
  subscribing,
  managing,
  error,
  onClose,
  onSubscribe,
  onManage,
}: SubscriptionSheetProps) => (
  <BottomSheet
    onClose={onClose}
    open={open}
    title={
      FREE_BETA && !currentPeriodEnd
        ? "Free during beta"
        : isSubscribed
          ? "Hazumu Pro"
          : "Publish your site"
    }
    titleId="subscription-sheet-title"
  >
    <SubscriptionSection
      cancelAtPeriodEnd={cancelAtPeriodEnd}
      currentPeriodEnd={currentPeriodEnd}
      error={error}
      isSubscribed={isSubscribed}
      managing={managing}
      onManage={onManage}
      onSubscribe={onSubscribe}
      subscribing={subscribing}
    />
  </BottomSheet>
);
